import React, { useEffect, useState } from 'react'
import {motion} from 'framer-motion'
import { IconArrowUp } from '@tabler/icons-react';

const BacktoTopButton = () => {
    const [showbtn,setShowBtn]=useState(false);

    useEffect(()=>{
        const handleScroll = ()=>{
            setShowBtn(window.scrollY > 300);
        }
        window.addEventListener('scroll',handleScroll);

        return()=>{
            window.removeEventListener('scroll',handleScroll);
        }
    },[])

    const ScrollToTop = ()=>{
        window.scrollTo({
            behavior:'smooth',
            top:0
        })
    }

    
  return (
    <>
    {
        showbtn && (
            <motion.button initial={{opacity:0,translateY:50}} whileInView={{opacity:1,translateY:0}} transition={{ease:'easeInOut',duration:0.8}} onClick={()=>ScrollToTop()} className='bg-primary fixed right-5 bottom-5 h-[50px] w-[50px] flex flex-col items-center justify-center rounded-full hover:bg-[#ad8594] z-50'><IconArrowUp size={18} className='h-4 w-4 fill-white stroke-white'/></motion.button>
        )
    }
    </>
  )
}

export default BacktoTopButton